import React, { useContext, useEffect, useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { AppContextProvider } from "../App";
import { CallToActionBanner } from "../Components/CallToActionBanner";
import { FlowsFilter } from "../Components/FlowsFilter";
import { useParams } from "react-router-dom";
import { categories } from "../Data/Homepage";
import { AiOutlineExclamation } from "react-icons/ai";
import figma from "../Components/AuthorDashboard/AddingProducts/Details/icons/Icon.png";
import sketch from "../Components/AuthorDashboard/AddingProducts/Details/icons/Icon (1).png";
import adobexd from "../Components/AuthorDashboard/AddingProducts/Details/icons/Icon (2).png";
import photoshop from "../Components/AuthorDashboard/AddingProducts/Details/icons/psd-icon.png";
import adobeill from "../Components/AuthorDashboard/AddingProducts/Details/icons/adobeIllustrator-icon.svg";
import canva from "../Components/AuthorDashboard/AddingProducts/Details/icons/canva-icon (1).svg";

import react from "../Components/AuthorDashboard/AddingProducts/Details/icons/Icon (5).png";
import tailwind from "../Components/AuthorDashboard/AddingProducts/Details/icons/tailwind-icon.svg";
import webflow from "../Components/AuthorDashboard/AddingProducts/Details/icons/webflow-icon.svg";
import vuejs from "../Components/AuthorDashboard/AddingProducts/Details/icons/vueJS-icon.svg";
import ionic from "../Components/AuthorDashboard/AddingProducts/Details/icons/Icon (4).png";
import bootstrap from "../Components/AuthorDashboard/AddingProducts/Details/icons/Icon (1).svg";
import angular from "../Components/AuthorDashboard/AddingProducts/Details/icons/angluar-icon (1).svg";
import html from "../Components/AuthorDashboard/AddingProducts/Details/icons/html5-icon (1).svg";
import {
  SiFigma,
  SiSketch,
  SiAdobexd,
  SiAdobephotoshop,
  SiAdobeillustrator,
  SiCanva,
} from "react-icons/si";
import MainComponent from "../Components/AllFlows/ParentComponent";

const options = [
  {
    id: 1,
    name: "Industry",
    children: [
      { name: "Artificial Intelligence", icon: null },
      { name: "Collaboration", icon: null },
      { name: "Education", icon: null },
      { name: "Finance", icon: null },
      { name: "Fitness", icon: null },
      { name: "Business", icon: null },
      { name: "Crypto", icon: null },
      { name: "Entertainment", icon: null },
      { name: "Food & Drink", icon: null },
      { name: "Health & Medical", icon: null },
    ],
  },
  {
    id: 2,
    name: "Tools",
    children: [
      { name: "Figma", icon: figma },
      { name: "Sketch", icon: sketch },
      { name: "Adobe XD", icon: adobexd },
      { name: "Photoshop", icon: photoshop },
      { name: "Adobe Illustrator", icon: adobeill },
      { name: "Canva", icon: canva },
    ],
  },
];

export const AllFlows = () => {
  const [showBrowse, setShowBrowse] = useState(false);
  const [size, setSize] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showApplyClear, setShowApplyClear] = useState(false);
  const [apply, setApply] = useState(false);
  const [itemsSelected, setItemsSelected] = useState([]);
  const { id } = useParams();
  const itemId = id.trim();
  const { showFilter } = useContext(AppContextProvider);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 700) {
        setSize(700);
      } else {
        setSize(0);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDropdown = (index) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  const handleCheckboxChange = (optionIndex, child) => {
    console.log(child, optionIndex);

    setItemsSelected((prevItems) => {
      const isSelected = prevItems.some(
        (item) => item.optionIndex === optionIndex && item.name === child.name
      );

      // Filter items based on selection state
      const newItems = isSelected
        ? prevItems.filter(
            (item) =>
              !(item.optionIndex === optionIndex && item.name === child.name)
          )
        : [...prevItems, { ...child, optionIndex }];

      // Determine if apply/clear button should be shown
      const shouldShowApplyClear = newItems.length > 0;

      // Update the state and show/hide buttons
      setShowApplyClear(shouldShowApplyClear);
      return newItems;
    });
  };

  return (
    <div className="px-6 lg:flex justify-between md:gap-[48px]">
      <FlowsFilter id={itemId} showBrowse={showBrowse} />
      <div className="py-4 w-full">
        {categories.map((cat) => {
          if (cat.category === id) {
            return (
              <div key={cat.category}>
                <div className="lg:flex justify-between items-center">
                  <div className="flex items-center lg:justify-between justify-center">
                    <div className="flex  space-x-2">
                      {/* <img
                        alt=""
                        src={cat.icon}
                        className="text-2xl mt-[10px] w-6 h-6 md:w-7 md:h-7 dark:text-[#C7C7C7]"
                      /> */}
                      <div className="mt-3">{cat.icon}</div>
                      <h1 className="text-[28px] md:text-[32px]">
                        {cat.category}
                      </h1>
                    </div>
                  </div>
                  <p className="md:w-1/2 mx-auto text-center py-3 lg:hidden">
                    Explore a wide selection of premium UI kits made by top
                    designers around the world
                  </p>

                  {/* Starts here - Tools and industry select options */}
                  {/* <MainComponent/> */}

                  <div className="flex items-center space-x-2 ">
                    {showDropdown && (
                      <div className="z-[6000] fixed inset-0 bg-black/60 md:hidden" />
                    )}
                    {options.map((option, index) => (
                      <div className="relative w-full" key={option.id}>
                        <div
                          className="flex dark:border-[#5B5B5B] justify-between items-center bg-transparent border rounded-lg px-4 py-1 w-full cursor-pointer"
                          onClick={() => {
                            toggleDropdown(index);
                            setShowDropdown(true);
                          }}
                        >
                          <div className="flex items-center space-x-2 ">
                            <p>{option.name}</p>
                            {apply && (
                              <div className="flex items-center space-x-2">
                                {/* Display the counter only if there are selected items */}
                                {itemsSelected.filter(
                                  (item) => item.optionIndex === index
                                ).length > 0 && (
                                  <p className="bg-black shrink-0 text-white h-5 w-5 flex items-center justify-center rounded-full dark:bg-white dark:text-black">
                                    {
                                      itemsSelected.filter(
                                        (item) => item.optionIndex === index
                                      ).length
                                    }
                                  </p>
                                )}
                                {/* Display selected items only if there are selected items */}
                                {itemsSelected.some(
                                  (item) => item.optionIndex === index
                                ) && (
                                  <div className="flex space-x-6">
                                    {itemsSelected.map((item) => {
                                      if (item.optionIndex === index) {
                                        return (
                                          <div
                                            className="flex shrink-0 items-center space-x-1"
                                            key={item.name}
                                          >
                                            <img
                                              alt={item.name}
                                              className="w-4 h-4 rounded-full shrink-0 object-cover"
                                              src={item.icon}
                                            />
                                            <p>x</p>
                                          </div>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          {dropdownOpen === index ? (
                            <FiChevronUp />
                          ) : (
                            <FiChevronDown />
                          )}
                        </div>
                        {dropdownOpen === index && (
                          <ul className="z-[7000] overflow-hidden overflow-y-auto fixed bottom-0 md:h-[550px] md:absolute md:top-10 rounded-t-2xl rounded-b-none md:rounded-lg text-[#1C1C1C] bg-[#F0F0F0] dark:bg-[#282828] w-full md:w-72 md:-left-[180px] left-0 px-4 py-4">
                            <div className="flex justify-between mb-3 dark:text-white">
                              <button
                                onClick={() => {
                                  setShowDropdown(false);
                                  toggleDropdown(null);
                                }}
                                className="dark:text-[#C7C7C7]"
                              >
                                X
                              </button>
                              <p className=" text-2xl ">
                                {dropdownOpen === index && option.name}
                              </p>
                              <div />
                            </div>
                            <div className="flex justify-between px-4 py-1 mb-4 rounded-md space-x-4 bg-[#2F2F2F]">
                              <AiOutlineExclamation className="bg-white mt-1 text-black rounded-lg p-1 text-3xl" />
                              <p className="text-white">
                                Certain filters may not be available based on
                                the industry options selected.
                              </p>
                              <button className="text-white">X</button>
                            </div>
                            <li className="flex items-center space-x-2 justify-between ">
                              <div className="space-x-2 flex items-center w-full">
                                <div className="grid grid-cols-2 gap-x-4 w-full gap-2 items-center justify-center align-middle md:grid-cols-1">
                                  {option.children.map((child, childIndex) => (
                                    <div
                                      className="flex justify-between p-2 shrink-0 h-10 overflow-y-scroll focus-within::border focus-within::border-[#6C6C6C] bg-[#E7E7E7] dark:bg-[#2F2F2F] rounded-xl "
                                      key={childIndex}
                                    >
                                      <div className="flex items-center space-x-2">
                                        {child.icon &&
                                        <img alt="child" src={child.icon} />
                                        }
                                        <p className="dark:text-white">{child.name}</p>
                                      </div>
                                      <input
                                        className="custom-checkbox"
                                        type="checkbox"
                                        checked={itemsSelected.some(
                                          (item) =>
                                            item.optionIndex === index &&
                                            item.name === child.name
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(index, child)
                                        }
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </li>
                            {showApplyClear &&
                              itemsSelected.filter(
                                (item) => item.optionIndex === index
                              ).length > 0 && (
                                <div className="flex space-x-2 items-center">
                                  <button
                                    onClick={() => {
                                      setItemsSelected([]);
                                      setShowApplyClear(false);
                                    }}
                                    className="border-[1.3px] w-full rounded-xl mt-3 px-4 py-2 text-[#1c1c1c] bg-white dark:bg-transparent dark:text-white dark:border-[#5B5B5B]"
                                  >
                                    Clear
                                  </button>
                                  <button
                                    onClick={() => setApply(true)}
                                    className="border w-full rounded-xl mt-3 px-4 py-2  bg-[#1c1c1c] text-white dark:bg-white dark:text-[#1c1c1c]"
                                  >
                                    Apply (
                                    {
                                      itemsSelected.filter(
                                        (item) => item.optionIndex === index
                                      ).length
                                    }
                                    )
                                  </button>
                                </div>
                              )}
                            {showApplyClear ? (
                              ""
                            ) : (
                              <button
                                onClick={() => {
                                  setShowDropdown(false);
                                  toggleDropdown(null);
                                }}
                                className="border-[1.3px] w-full rounded-xl mt-3 px-4 py-2 bg-white text-[#1C1C1C]"
                              >
                                Cancel
                              </button>
                            )}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                  {/* Ends here - Tools and industry select options */}
                </div>
                <div
                  className={`gap-5 grid md:grid-cols-2 lg:grid-cols-3 py-4`}
                >
                  {cat.cards.map((card, cardIndex) => (
                    <div key={cardIndex}>
                      <div className="w-full h-60 bg-gray-400 rounded-2xl">
                        <img
                          className="w-full h-full object-cover rounded-2xl"
                          src={card.picture}
                          alt=""
                        />
                      </div>
                      <div className="flex justify-between space-x-4 pt-3 items-center">
                        <p className="py-2 text-lg font-[500]">{card.header}</p>
                        <p className="bg-[#1C1C1C] py-1 px-2 text-white dark:bg-[#FFFFFF] dark:text-black rounded-lg w-fit">
                          {card.price}
                        </p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <img
                          src={card.user.picture}
                          className="w-6 h-6 rounded-full"
                          alt=""
                        />
                        <p className="text-md">By {card.user.name}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
      <div
        className={
          showFilter
            ? "overflow-y-scroll fixed top-0 left-0 w-full bg-white h-full"
            : "hidden"
        }
      >
        <FlowsFilter id={itemId} showBrowse={showBrowse} />
      </div>
      <div className="md:hidden">
        <CallToActionBanner
          att="bg-[#1c1c1c] text-white dark:bg-white dark:text-[#1c1c1c]"
          buttonColor="bg-white text-[#1c1c1c] dark:bg-[#1c1c1c] dark:text-white"
        />
      </div>
    </div>
  );
};
